import { createContext } from "react";

const AgendaContext = createContext();

export default AgendaContext;
